export const CLOS = 'Clos';
export const OUVERT = 'Ouvert';

export const LISTE_ETAT = [
  { libelle: 'addExerciceComptable.etat.ouvert', code: OUVERT },
  { libelle: 'addExerciceComptable.etat.ferme', code: CLOS },
];
